import React, { useContext } from 'react';
import { useHistory } from 'react-router';
import {
  CanAccessPartnerData,
  ViewerContext,
} from '../providers/ViewerContextProvider';
import { Communicator } from '../tools/Communication';

interface IUrlParameters {
  match: {
    params: {
      merchantId?: string;
      storeId?: string;
    };
  };
}

interface StoreInfo {
  externalStoreId?: string;
  externalMerchantId?: string;
}

export default function LegacyMerchantLinkRedirect(urlParams: IUrlParameters) {
  const viewer = useContext(ViewerContext);
  const history = useHistory();

  const allowedToAccess = CanAccessPartnerData(viewer);
  if (allowedToAccess) {
    Communicator.Get('/Merchant/GetExternalMerchantAndMerchantStoreIds', {
      storeId: urlParams.match.params.storeId,
      merchantId: urlParams.match.params.merchantId,
    })
      .then((result) => result.json())
      .then((storeInfo: StoreInfo) => {
        if (storeInfo.externalStoreId && storeInfo.externalMerchantId) {
          history.replace(
            `/partner/brand/${storeInfo.externalMerchantId}/store/${storeInfo.externalStoreId}`,
          );
        } else if (storeInfo.externalMerchantId) {
          history.replace(`/partner/brand/${storeInfo.externalMerchantId}`);
        } else {
          history.replace(`/partner/brand`);
        }
      });
  }

  return <div />;
}
